import React from "react";
import styles from "./YesNoToggle.module.scss";

interface YesNoToggleButtonProps {
  value: boolean;
  onChange: (newValue: boolean) => void;
  label?: string;
}

const YesNoToggleButton: React.FC<YesNoToggleButtonProps> = ({
  value,
  onChange,
  label,
}) => {
  return (
    <div className={styles.toggleWrapper}>
      {label && <span className={styles.toggleLabel}>{label}</span>}
      <label className={styles.toggle}>
        <input
          type="checkbox"
          checked={value}
          onChange={() => onChange(!value)}
          className={styles.toggleInput}
        />
        <span className={`${styles.slider} ${value ? styles.green : styles.red}`}>
          <span className={`${styles.text} ${value ? styles.textYes : styles.textNo}`}>
            {value ? "YES" : "NO"}
          </span>
        </span>
      </label>
    </div>
  );
};

export default YesNoToggleButton;
